export default __webpack_public_path__ + "static/media/01 Marketing - Floor Plan by Type 4.cc34b7dd.jpeg";